<ul>
  @for (resource of _resources; track resource) {
    <li>
      <figure aria-hidden="true">
        <a class="red-text-link"
          [href]="resource.href ?? '#'"
          [attr.role]="resource.href ? 'link' : 'button'"
          [target]="resource.href ? '_blank' : ''"
          [attr.aria-label]="resource.caption"
         (click)="resource.wistiaCode
         ? playVideo($event, resource.wistiaCode)
         : undefined">
          <img [ngSrc]="resource.thumbnailSrc"
            [alt]="resource.thumbnailAlt"
            width="160" height="100"
            />
          <figcaption [innerHTML]="resource.caption">
          </figcaption>
        </a>
      </figure>
    </li>
  }
</ul>
